/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Stat_2_LabelInputs */

const tr_landing_intro_stat_2_label = /** @type {(inputs: Landing_Intro_Stat_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yapay zeka asistanı`)
};

const en_landing_intro_stat_2_label = /** @type {(inputs: Landing_Intro_Stat_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI assistant`)
};

const de_landing_intro_stat_2_label = /** @type {(inputs: Landing_Intro_Stat_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Assistent`)
};

const ru_landing_intro_stat_2_label = /** @type {(inputs: Landing_Intro_Stat_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-ассистент`)
};

/**
* | output |
* | --- |
* | "AI assistant" |
*
* @param {Landing_Intro_Stat_2_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_stat_2_label = /** @type {((inputs?: Landing_Intro_Stat_2_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Stat_2_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_stat_2_label(inputs)
	if (locale === "de") return de_landing_intro_stat_2_label(inputs)
	if (locale === "ru") return ru_landing_intro_stat_2_label(inputs)
	return tr_landing_intro_stat_2_label(inputs)
});